import React from 'react';
import { DistributorIcon } from '../../assets/icons';
import RoleCreatePage from '../RoleManagement/RoleCreatePage';
import { ROLE_CONFIGS } from '../RoleManagement/roleConfig';
import styles from './DistributorCreatePage.module.css';

const DistributorCreatePage: React.FC = () => (
  <RoleCreatePage config={ROLE_CONFIGS.distributor} styles={styles} Icon={DistributorIcon} />
);

export default DistributorCreatePage;
